<script>
  import { onMount } from "svelte";
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import "./aomdMap.css";
  import { LeafletMap, ImageOverlay } from "./svelteLeafletWrapper";
  import imageUrl from "./map_base.png";
  import FairwayMarker from "./component/FairwayMarker.svelte";
  import ShipMarker from "./component/ShipMarker.svelte";
  import StationMarker from "./component/StationMarker.svelte";

  const minZoom = 2,
    maxNativeZoom = 4,
    maxZoom = 5;
  const mapOptions = {
    center: [-30, 30],
    crs: L.CRS.Simple,
    zoom: 3,
    minZoom,
    maxZoom,
  };

  function createImageBounds() {
    if (!leafletMap) {
      return [0, 0, 0, 0];
    }
    const map = leafletMap.getMap();
    return L.latLngBounds([
      map.unproject([0, 1100], maxNativeZoom),
      map.unproject([1100, 0], maxNativeZoom),
    ]);
  }

  let leafletMap;
  export let sectorId;
  export let map;
  export let width = "500px";
  export let height = "500px";

  onMount(() => {
    const map = leafletMap.getMap();
    const imageBounds = createImageBounds();
    map.setMaxBounds(imageBounds.pad(0.5));
  });
</script>

<div style="height: {height};width: {width}">
  <LeafletMap bind:this={leafletMap} options={mapOptions}>
    {#if leafletMap}
      <ImageOverlay {imageUrl} bounds={createImageBounds()} />
      {#each map.stations as station}
        <StationMarker {station} />
      {/each}
      {#each map.fairway as fairway}
        <FairwayMarker {sectorId} {fairway} />
      {/each}
      {#each map.ships as ship}
        <ShipMarker {ship} />
      {/each}
    {/if}
  </LeafletMap>
</div>